import React, { FC } from "react";

import { useStyles } from "../../useStyles";

type Props = {
    text: string;
};

export const TopAreaText: FC<Props> = (props: Props) => {
    const classes = useStyles();
    return (
        <p className={classes.p} style={{ marginLeft: 20, marginRight: 20 }}>
            {props.text}
        </p>
    );
};
